var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"carrier-message"},[_c('h1',[_vm._v(" Are you looking for something else? "),_c('a',{attrs:{"href":"mailto:ltl@goglt.com","target":"_blank"}},[_vm._v("Contact us now!")])])])
}]

export { render, staticRenderFns }